import { cn } from '@/lib/utils'

/**
 * Nested expandable section — LMS admin-collapse-section style (details/summary + arrow).
 */
export function CollapseSection({
  title,
  subtitle,
  open,
  onOpenChange,
  className,
  bodyClassName,
  children,
}) {
  return (
    <details
      className={cn('collapse-section', className)}
      open={open}
      onToggle={(event) => onOpenChange?.(event.currentTarget.open)}
    >
      <summary>
        <span className="collapse-section-summary">
          {title}
          {subtitle ? <span>{subtitle}</span> : null}
        </span>
      </summary>
      <div className={cn('collapse-section-body', bodyClassName)}>{children}</div>
    </details>
  )
}
